import Layout from '@/layout';

export default {
  weight: 2,
  path: '/admin',
  component: Layout,
  redirect: '/adminList',
  name: 'admin',
  meta: { title: '权限管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'adminList',
      name: 'adminList',
      component: () => import('@/views/admin/adminList'),
      meta: { title: '管理员', icon: 'el-icon-s-data' },
    },
    {
      path: 'adminDetails',
      name: 'adminDetails',
      component: () => import('@/views/admin/adminDetails'),
      meta: { title: '权限详情', icon: 'el-icon-s-data', activeMenu: '/admin/adminList' },
      hidden: true,
    },
    {
      path: 'resetPassword',
      name: 'resetPassword',
      component: () => import('@/views/admin/resetPassword'),
      meta: { title: '修改登录密码', icon: 'el-icon-s-data' },
    },
  ],
};
